import { couponBenefitText } from '@euler/functions/apdm/couponRedemption';
import {
  ApdmCouponCampaignStatus,
  ApdmCouponCampaignSummary,
  CouponCampaignPublicViewItem,
} from '@euler/model/apdm';
import dayjs from 'dayjs';

export function couponItemText(item: CouponCampaignPublicViewItem): string {
  return `${item.label} · ${couponBenefitText(item.benefit)} ×${item.qty}${
    item.qtyUnit ?? ''
  }`;
}

export function couponPeriodText(
  coupon: Pick<ApdmCouponCampaignSummary, 'startsAt' | 'endsAt'>,
): string {
  const from = dayjs(coupon.startsAt);
  const to = dayjs(coupon.endsAt);
  const format = from.year() === to.year() ? 'M月D日' : 'YYYY年M月D日';
  return `${from.format(format)} – ${to.format(format)}`;
}

export function couponStockText(coupon: ApdmCouponCampaignSummary): string {
  return [
    coupon.stockLeft == null ? '不限量' : `剩余 ${coupon.stockLeft} 份`,
    `已核销 ${coupon.redeemedCount}`,
  ].join(' · ');
}

export const kCouponStatusLabels: Record<ApdmCouponCampaignStatus, string> = {
  [ApdmCouponCampaignStatus.Draft]: '待发布',
  [ApdmCouponCampaignStatus.Scheduled]: '未开始',
  [ApdmCouponCampaignStatus.Active]: '进行中',
  [ApdmCouponCampaignStatus.Paused]: '已暂停',
  [ApdmCouponCampaignStatus.Ended]: '已结束',
};
